import React from 'react'

export const UseAndContractTermLink = () => {
    return (
        <a href="https://adrenalyze-app.s3-sa-east-1.amazonaws.com/adrenalyze/Contrato+de+Serv+Manut+Sup+OffStation+V4-20.pdf" target="_blank">Termo de Uso e Contrato de Prestação de Serviços</a>
    )
}
